import { slideMapID } from "./slideMap";
export function removeAllHighlights() {
    const rooms = document.querySelectorAll(`#${slideMapID} .active`);
    for (let i = 0, l = rooms.length; i < l; i++) {
        rooms[i].classList.remove("active");
    }
}
